import type { RouteRecordRaw } from 'vue-router';

import NotFound from '@/shared/NotFound.vue';

/**
 * Lowest priority route, matching everything no other route matched. New routes must be added above
 * it in the route table.
 *
 * The page renders in place so that the address the user typed or followed stays visible, instead of
 * silently sending them somewhere else. Urls from the old hash based routing reach this route too,
 * but the global rewriteLegacyRouteUrls guard rewrites them before it is entered.
 *
 * Note that this is a soft 404: the server serves index.html for every unmatched path
 * (`MapFallbackToFile` in Statoil.TI.CommonLibrary.UI/Program.cs), so the response status is still
 * 200. Returning a real 404 would mean duplicating this route table in the backend, which would
 * inevitably drift out of sync.
 */
export const notFoundRoute: RouteRecordRaw = {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
        title: 'Not Found',
        requireAuth: false
    }
};
